import React, { Component } from 'react';

import { withRouter } from "react-router-dom";
import CircularProgress from '@material-ui/core/CircularProgress';

// import Table from "@material-ui/core/Table";
// import TableBody from "@material-ui/core/TableBody";
// import TableCell from "@material-ui/core/TableCell";
// import TableHead from "@material-ui/core/TableHead";
// import TableRow from "@material-ui/core/TableRow";

import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import { TextField } from '@material-ui/core';
// import Avatar from '@material-ui/core/Avatar';
// import Typography from '@material-ui/core/Typography';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import "../common/style.css";
import { getLocalData } from '../adapter/UserInfo';
import QRCode from "react-qr-code";


/*
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
*/
import DateFnsUtils from '@date-io/date-fns';


import { getStudentDataForAdhaar } from '../adapter/infoURL';


class StudentID extends Component {


  getLocalStorage = async () => {
  let user = await getLocalData();
// console.log("\n\n\n\nUser Data\n\n\n\n", user.data);
  return user.data;
} 


state = {
opensSuccessDialog: false,
open: false,
connected: true,
errorMessage: "",
exception: false,
status: false,
studentId: "",
sinfo: [],
}

getStudentId = async ()  => {
let data = await this.getLocalStorage();
// console.log("Student Id: ", data.studentDetail.studentId);
this.setState({studentId: data.studentDetail.studentId});
return data.studentDetail.studentId;
}

checkSpecialChar(valu) {
var val=valu;
var status = false;
for(var i=0;i<val.length;i++) {
if(val.charAt(i)==';' || val.charAt(i)=='"' || val.charAt(i)=='!' || val.charAt(i)=='$' || val.charAt(i)=='%' || val.charAt(i)=='(' || val.charAt(i)==')' || val.charAt(i)=='*' || val.charAt(i)==':' || val.charAt(i)==';' || val.charAt(i)=='<' || val.charAt(i)=='=' || val.charAt(i)=='>' || val.charAt(i)=='?' || val.charAt(i)=='@' || val.charAt(i)=='[' || val.charAt(i)==']' || val.charAt(i)=='^' || val.charAt(i)=='`' || val.charAt(i)=='|' || val.charAt(i)=='{' || val.charAt(i)=='}' || val.charAt(i)=='~' || val[i]=="'") {
status = true;
break;
}
}
return status;
}







/*

getMonth(event) {
var evt=""+event;
var month="01";
if(evt.substring(4,7)=="Jan")
month="01";
else if(evt.substring(4,7)=="Feb")
month="02";
else if(evt.substring(4,7)=="Mar")
month="03";
else if(evt.substring(4,7)=="Apr")
month="04";
else if(evt.substring(4,7)=="May")
month="05";
else if(evt.substring(4,7)=="Jun")
month="06";
else if(evt.substring(4,7)=="Jul")
month="07";
else if(evt.substring(4,7)=="Aug")
month="08";
else if(evt.substring(4,7)=="Sep")
month="09";
else if(evt.substring(4,7)=="Oct")
month="10";
else if(evt.substring(4,7)=="Nov")
month="11";
else if(evt.substring(4,7)=="Dec")
month="12";
return month;
}

getDay(event) {
var evt=""+event;
return evt.substring(8,10);
}

getYear(event) {
var evt=""+event;
return evt.substring(11,15);
}
*/


printpage = () => {
var prtContent = window.document.getElementById("printpage");
var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
WinPrint.document.write(prtContent.innerHTML);
WinPrint.document.close();
WinPrint.focus();
WinPrint.print();
WinPrint.close();
}

handleCloseConnection = () => { this.setState({connected: false}) };
handleOpenConnection = () => this.setState({connected: true});

handleClickOpen = () => this.setState({ open: true });
handleClose = () => this.setState({ open: false });

handleOpenSuccessDialog = () => this.setState({opensSuccessDialog: true});
handleCloseSuccessDialog = () => this.setState({opensSuccessDialog: false});




submitRequest = async () => {

await this.setState({exception: false});
this.getStudentId();

var message="";
/*
if(this.state.exception==true && message.length > 0) {
// window.alert(this.state.exception);
// await this.setState({errorMessage: message});
setTimeout(function() {
window.alert("Message:\n"+message);
}, 100);
return;
}
*/

this.indata = {
"studentId": `${this.state.studentId}`,
}
// alert({this.state.studentId});

if(this.state.exception==false) {
await this.setState({status: true});
var info = await getStudentDataForAdhaar(this.indata);
if(info==null) {
this.setState({connected: false});
return null;
}
// console.log(info.data);
this.setState({sinfo: info.data});
// console.log(info.data.message, info.data.error);
if(info.data.message && info.data.message=="success") {

}
else if (info.data.message && info.data.message=="error" ) {
var allerrors=""
var data=info.data.error;
for(var i=0;i<data.length;i++) { allerrors += "\n"+data[i]}
setTimeout(function() {
window.alert("Message:\n"+allerrors);
}, 100);
}
else if(info.data && info.data.message && (info.data.message != "error" || info.data.message != "success")) {
setTimeout(function() { window.alert("Exception Message:\n"+info.data.message); }, 100);
}
else if(info==null) {
setTimeout(function() { window.alert("Please Check Internet Connection"); }, 100);
}
}
else {
setTimeout(function() {
window.alert("Please Check The Filled Information");
}, 100);
}
await this.setState({status: false});
}

async componentDidMount() {
await this.submitRequest();
// console.log("\n\n\nsem list\n\n\n", `${this.state.semesterList}`)
}



getLast8Digits() {
var adhaarId = this.state.sinfo.adhaarId.trim();
adhaarId = adhaarId.replace(" ","");
adhaarId = adhaarId.replace("-","");
if(adhaarId.length <= 8) {
return "";
}
var last8 = adhaarId.substr(adhaarId.length - 8);
return last8;
}



render() {

const compwidth = {
minWidth: "200px", position: "relative", float: "left", margin: "10px"
};


if( this.state.connected == true) {

return (


<div>
<div>
<div style={{border: "1px sold #777"}} id="printpage">

<div style={{width: "100%"}}>
<br/>
<div  align="center" style={{fontSize: '20px'}}>IDENTIFICATION</div>
</div>

<div align="center" style={{width: "100%", color: "#f00",  margin: "auto"}}>

<div align= "left" style={{width: "100%", margin: "10px", color: "#000"}}>

<br/>
<div style={compwidth}><b>Name:</b> { this.state.sinfo.name }</div>
<div style={compwidth}><b>Pan Id:</b> { this.state.sinfo.panId } </div>
<div style={compwidth}><b>Adhaar Id:</b> { this.state.sinfo.adhaarId } </div>
<div style={compwidth}><b>Nad Id:</b> { this.state.sinfo.nadId }</div>
</div>

<div><br/><br/><br/><br/></div>
<div align="center" style={{ width: "256px" }}>
 {((this.state.sinfo.isJR == "1")  && (this.getLast8Digits().length==8)) ? 
<div style={compwidth}>For Biometric Attendance<br/>
<div align="center" style={{ margin: "0 auto", height: "auto"}}>
  <QRCode
    size={256}
    style={{ height: "auto", maxWidth: "100%", width: "100%" }}
    value={ this.getLast8Digits() }
    viewBox={`0 0 256 256`}
  />
<br/>
{this.getLast8Digits()}
</div>
</div>
 : ""}

{ this.state.status ? <div align="center"><CircularProgress className="loader" variant='indeterminate' color='secondary' /></div>  : "" }

 { this.state.connection==false ? <div style={{color: "red", textAlign: "center"}}><br/><br/>Problem Uploading File,<br/>Please Check Internet Connection/Speed!</div>:"" }


</div>



</div>

<div>

</div>
</div>
</div>

</div>
);
}
else {
return (
<div>
<div style={{width: "100%"}}>
<br/>
<div  align="center" style={{fontSize: '20px'}}>IDENTIFICATION</div>
</div>

<div>
<br/>
 {(this.state.connected!==true) ? (<Typography style={{color: '#ff0000'}} align="center">Internet Or Data Not Available<br/></Typography>) : ""}
</div>
</div>
);
}
}

}

export default withRouter(StudentID);

{/*
<MuiPickersUtilsProvider utils={DateFnsUtils}>
            
        <KeyboardDatePicker
          margin="normal"
          id="Date From"
          label="Date From"
          format="yyyy-MM-dd"
          value={`${this.state.transactionDatetimeFrom}`}
          onChange={e => this.handlePeriodFromDisqualificationChange(e)}
          KeyboardButtonProps={{
            'aria-label': 'change date',
          }}
        />
<br/>
<br/>
<KeyboardDatePicker
          margin="normal"
          id="Date To"
          label="Date To"
          format="yyyy-MM-dd"
          value={`${this.state.transactionDatetimeTo}`}
	onChange={e => this.handlePeriodToDisqualificationChange(e)}
          KeyboardButtonProps={{
            'aria-label': 'change date',
          }}
        />
        
    </MuiPickersUtilsProvider>

*/}





